// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { isInstalledPwaSelector } from './store/pwaAppSelector';

const mapStateToProps = createStructuredSelector({
    isInstalledPwa: isInstalledPwaSelector,
});

const PwaOnly = ({ isInstalledPwa, children }) => (isInstalledPwa ? React.Children.only(children) : null);

PwaOnly.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    isInstalledPwa: PropTypes.bool,
};

export default connect(mapStateToProps)(PwaOnly);
